/**
 * ErrorMessage Component
 * Clean error display with icon
 */

import React from 'react';
import './ErrorMessage.css';

interface ErrorMessageProps {
  title: string;
  message: string;
  code?: string;
  details?: any;
  suggestions?: string[];
  onSuggestionClick?: (suggestion: string) => void;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ 
  title, 
  message, 
  code,
  details,
  suggestions,
  onSuggestionClick 
}) => {
  return (
    <div className="error-message">
      <div className="error-message-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      </div>
      
      <div className="error-message-content">
        <div className="error-message-title">{title}</div>
        <div className="error-message-text">{message}</div>
        
        {code && (
          <div className="error-message-code">Error Code: {code}</div>
        )}
        
        {details && typeof details === 'object' && (
          <div className="error-message-details">
            {details.yourRole && (
              <div className="error-detail-row">
                <span className="error-detail-label">Your Role:</span>
                <span className="error-detail-value">{details.yourRole}</span>
              </div>
            )}
            {details.requiredRole && (
              <div className="error-detail-row">
                <span className="error-detail-label">Required Role:</span>
                <span className="error-detail-value">{details.requiredRole}</span>
              </div>
            )}
          </div>
        )}
        
        {suggestions && suggestions.length > 0 && (
          <div className="error-message-suggestions">
            <div className="error-suggestions-label">Try instead:</div>
            <div className="error-suggestions-chips">
              {suggestions.map((suggestion, index) => (
                <button
                  key={index}
                  className="error-suggestion-chip"
                  onClick={() => onSuggestionClick?.(suggestion)}
                >
                  {suggestion}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ErrorMessage;
